module.exports = __webpack_public_path__ + "media/pk_tab.e6e7a534.mp3";